import { Injectable, inject, isDevMode } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { PwaUpdaterDialogComponent } from '@components/dialogs/pwa-updater-dialog/pwa-updater-dialog.component';
import { GeneralService } from '@shared/services/general.service';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PromptUpdateService {
  private readonly generalService = inject(GeneralService);
  private readonly dialog = inject(MatDialog);
  private readonly swUpdate = inject(SwUpdate);

  constructor() {
    if (this.generalService.isBrowserOnly && !isDevMode()) {
      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe((res) => {
          const updaterDialog = this.dialog.open(PwaUpdaterDialogComponent, {
            backdropClass: 'pwa-updater-dialog-backdrop',
          });
          updaterDialog.afterClosed().subscribe({
            next: (res) => {
              if (res) {
                document.location.reload();
              }
            },
          });
        });
    }
  }
}
